import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { markAnnouncementSeen, registerAppEntry } from 'utils/whatsNew';
import { ANNOUNCEMENT_SKIP_PATHS } from './data/announcement';

const MAIN_PAGE_PATH = '/';

/**
 * סופר כניסות לתוכנה ומפנה אוטומטית לדף "מה חדש" עד `ANNOUNCEMENT.autoShowTimes`
 * פעמים לגרסה הנוכחית. אחרי זה הדף נשאר בתפריט בלי הפניה. מותקן ב-MainLayout
 * שנטען פעם אחת לכל טעינת אפליקציה (אין StrictMode ב-`index.tsx`).
 */
const WhatsNewGate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn } = useAuth();
    const alreadyRan = useRef(false);

    useEffect(() => {
        // MainLayout נטען גם לפני שההתחברות הושלמה (AuthGuard מפנה ל-login
        // מתוך effect) — סופרים כניסה רק למשתמש מזוהה, אחרת המונה נשמר
        // תחת מפתח בלי חברה ומשתמש
        if (!isLoggedIn || alreadyRan.current) return;
        alreadyRan.current = true;

        const { shouldShow } = registerAppEntry();
        if (!shouldShow) return;

        const enteredAt = `${location.pathname}${location.search}`;
        const isSkippedPath =
            ANNOUNCEMENT_SKIP_PATHS.some((path) => location.pathname.includes(path)) || new URLSearchParams(location.search).has('code');
        if (isSkippedPath) return;

        markAnnouncementSeen();
        // מי שכבר נמצא בדף רואה את ההכרזה בלי הפניה
        if (location.pathname !== MAIN_PAGE_PATH) {
            navigate(MAIN_PAGE_PATH, { state: { whatsNewReturnTo: enteredAt } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    return null;
};

export default WhatsNewGate;
